import MessageBoxViewModelT from '@/ViewModels/Controls/MessageBoxViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import ResourceManager from '@/Management/ResourceManager';
export default class Error404ViewFactory extends ViewFactory {
    private MessageBoxViewModel: any;
    constructor(params: any) {
        super(params);
        this.MessageBoxViewModel = ComponentManager.getViewModel<typeof MessageBoxViewModelT>('MessageBoxViewModel');
    }
    public getView(): any {
        let message = ResourceManager.getInstance().get('PAGE_NOT_FOUND')
        RADApplication.getInstance().showMessageBox(this.MessageBoxViewModel.createErrorMessageBox(message));
        return $();
    }
    public getNecessaryRedirect(): any {
        return false;
    }
}

ComponentManager.setFactory('Error404', Error404ViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('PAGE_NOT_FOUND', Error404ViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');